module.exports = __webpack_public_path__ + "static/media/LP5.94c6534f.svg";